// ============================================================
// Pre-Post Care — DYNAMIC + MULTI-SUBMENU SUPPORT
// ============================================================

document.addEventListener("DOMContentLoaded", () => {
  const filtersList = document.querySelector(".filtersList");
  const qaItems = document.querySelectorAll(".careItem");

  if (!filtersList) return;

  const clearActive = () => qaItems.forEach(i => i.classList.remove("active"));
  const baseClasses = [
    "droid-mono",
    "body",
    "uppercase",
    "darkText",
    "filterItem",
    "filterItemSub",
    "laserTreatments"
  ];

  // Get ALL laserTreatments sections (there are now multiple)
  const laserSections = filtersList.querySelectorAll(".laserTreatments");

  // Helper: remove "active" from every main filterItem (not sub items)
  const removeActiveFromAllFilterItems = () => {
    filtersList.querySelectorAll("li.filterItem").forEach(el => el.classList.remove("active"));
  };

  // Helper: remove "active" from all sub items inside ALL laserSections
  const removeActiveFromAllSubItems = () => {
    laserSections.forEach(section => {
      section.querySelectorAll("li.filterItemSub").forEach(el => el.classList.remove("active"));
    });
  };

  // Helper: close all laserTreatments submenus
  const closeAllSubmenus = () => {
    laserSections.forEach(section => {
      section.classList.remove("active");
    });
  };

  // Helper: activate a given filter li (adds .active and shows matching careItem)
  const activateFilterAndQA = (li) => {
    if (!li) return;
    // clear other li actives
    filtersList.querySelectorAll("li").forEach(el => el.classList.remove("active"));
    removeActiveFromAllFilterItems(); // ensure main items cleared
    // mark this one active
    li.classList.add("active");
    // show related care items
    clearActive();
    const key = [...li.classList].find(c => !baseClasses.includes(c));
    if (key) document.querySelectorAll(`.careItem.${key}`).forEach(i => i.classList.add("active"));
  };

  // ---------------------------------------------
  // Handle clicks on BOTH main and sub filters
  // ---------------------------------------------
  filtersList.addEventListener("click", e => {
    let li = e.target.closest("li");
    const span = e.target.closest("span.laserlabel");
    const clickedSubmenuParent = e.target.closest(".laserTreatments");

    // If clicking on the laserTreatments div or its label (but NOT on a sub-item li)
    if (clickedSubmenuParent && !li) {
      const parentDiv = clickedSubmenuParent;
      const wasActive = parentDiv.classList.contains("active");

      // Close all OTHER submenus first
      laserSections.forEach(section => {
        if (section !== parentDiv) {
          section.classList.remove("active");
          section.querySelectorAll("li.filterItemSub").forEach(el => el.classList.remove("active"));
        }
      });

      parentDiv.classList.toggle("active");

      if (!wasActive) {
        // Submenu opened: remove active from main filters, clear content, then activate first sub-item
        removeActiveFromAllFilterItems();
        clearActive();
        const firstSub = parentDiv.querySelector("li.filterItemSub");
        if (firstSub) {
          // Mark the first sub item active and show its care items
          firstSub.classList.add("active");
          const key = [...firstSub.classList].find(c => !baseClasses.includes(c));
          if (key) document.querySelectorAll(`.careItem.${key}`).forEach(i => i.classList.add("active"));
        }
      } else {
        // Submenu closed: remove active from sub items and clear content
        parentDiv.querySelectorAll("li.filterItemSub").forEach(el => el.classList.remove("active"));
        clearActive();
      }
      return;
    }

    // If clicking on a sub-item inside a laserTreatments submenu
    if (li && li.classList.contains("filterItemSub") && clickedSubmenuParent) {
      // Keep the parent submenu open, just activate this sub-item
      filtersList.querySelectorAll("li.filterItemSub").forEach(el => el.classList.remove("active"));
      removeActiveFromAllFilterItems();
      li.classList.add("active");
      clearActive();
      const key = [...li.classList].find(c => !baseClasses.includes(c));
      if (key) document.querySelectorAll(`.careItem.${key}`).forEach(i => i.classList.add("active"));
      return;
    }

    if (!li) return;

    // If a main filter is clicked, collapse ALL laserTreatments submenus and remove sub-item actives
    if (li.classList.contains("filterItem")) {
      closeAllSubmenus();
      removeActiveFromAllSubItems();
    }

    // If clicking a sub item or main item -> activate that filter and related content
    activateFilterAndQA(li);
  });

  // ---------------------------------------------
  // Default load state (first filter active)
  // ---------------------------------------------
  const firstActive =
    filtersList.querySelector("li.active") || filtersList.querySelector("li.filterItem");

  // Check if any laser section is active on load
  let activeLaserSection = null;
  laserSections.forEach(section => {
    if (section.classList.contains("active")) {
      activeLaserSection = section;
    }
  });

  if (activeLaserSection) {
    removeActiveFromAllFilterItems();
    clearActive();
    const firstSub = activeLaserSection.querySelector("li.filterItemSub");
    if (firstSub) {
      firstSub.classList.add("active");
      const key = [...firstSub.classList].find(c => !baseClasses.includes(c));
      if (key) document.querySelectorAll(`.careItem.${key}`).forEach(i => i.classList.add("active"));
    }
  } else if (firstActive) {
    // If the default active element is a main filter, ensure all laser submenus are closed
    if (firstActive.classList.contains("filterItem")) {
      closeAllSubmenus();
    }
    // activate the firstActive's content (already has .active in markup)
    const key = [...firstActive.classList].find(c => !baseClasses.includes(c));
    if (key) document.querySelectorAll(`.careItem.${key}`).forEach(i => i.classList.add("active"));
  }
});